export const TABBED_TOOLBAR_SET_ACTIVE_TAB = 'TABBED_TOOLBAR_SET_ACTIVE_TAB';
export const TABBED_TOOLBAR_SET_MAX_TAB = 'TABBED_TOOLBAR_SET_MAX_TAB';
export const TABBED_TOOLBAR_SET_TABS = 'TABBED_TOOLBAR_SET_TABS';
export const TABBED_TOOLBAR_SET_TABS_ENABLED = 'TABBED_TOOLBAR_SET_TABS_ENABLED';

export default {
  TABBED_TOOLBAR_SET_ACTIVE_TAB,
  TABBED_TOOLBAR_SET_MAX_TAB,
  TABBED_TOOLBAR_SET_TABS,
  TABBED_TOOLBAR_SET_TABS_ENABLED,
};



// WEBPACK FOOTER //
// ./src-react/TabbedToolbar/TabbedToolbarConstants.js